<template>
  <div class="loading-container">
    <div  class="main">
            <p>加入购物车中，请稍等...</p>
    <el-progress
      :stroke-width="26"
      :percentage="percentage2"
      :color="customColors"
     
    ></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      percentage2: 0,

      customColors: [
        { color: "#f56c6c", percentage: 20 },
        //   {color: '#e6a23c', percentage: 40},
        //   {color: '#5cb87a', percentage: 60},
        //   {color: '#1989fa', percentage: 80},
        //   {color: '#6f7ad3', percentage: 100}
      ],
    };
  },
  methods: {},
  mounted() {
    setInterval(() => {
      this.percentage2 = (this.percentage2 % 100) + 10;
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  height: 100vh;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
  .main {
    width: 400px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) !important;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>